import { render, staticRenderFns } from "./VlaanderenLogo.vue?vue&type=template&id=180aa579"
import script from "./VlaanderenLogo.vue?vue&type=script&lang=ts"
export * from "./VlaanderenLogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports